import { HandleSize, isCovered, checkEleOverflow } from "./tools.js"
const minDistance = 5 // 两两连通的组件的最小间距
/**
 *
 * @param {Number} followIndex 集合中当前元素指向的根节点数组下标，当当前元素为一个单独体，没有与任何其他元素连通时，则当前值为数组下标
 * @param {Number} rootIndex 集合中当前元素的指向，当当前元素为一个单独体，没有与任何其他元素连通时，则当前值为数组下标，反之为所连通对象的数组下标
 * @param {Number} myIndex 集合中当前元素的真实数组下标
 * @param {String|null} type 当前元素与所连通元素的关系，如果有所连通元素，则表示当前元素处于所连通元素的相对位置的字符串描述，如果没有则为null
 */
function item_union(index, type) {
  this.followIndex = null
  this.rootIndex = index
  this.myIndex = index
  this.des = type
}
/**
 * 并查集,这种数据结构,用于处理组件之间的对齐关系,包含水平的上中下对齐,垂直的左中右对齐,紧贴对齐
 */
class union_merge {
  constructor(len = 1000) {
    this.arr = []
    for (let i = 0; i < len; i++) {
      this.arr[i] = new item_union(i, null)
    }
  }
  find(index) {
    return this.arr[index].rootIndex === index ? index : this.find(this.arr[index].rootIndex)
  }
  /**
   *
   * @param {Number} a 数组中，被指向的值的数组下标
   * @param {Number} b 数组中，指向的值的数组下标
   */
  merge(a, b, type) {
    this.arr[b].followIndex = this.arr[a].myIndex
    this.arr[b].rootIndex = this.arr[this.find(a)].rootIndex
    this.arr[b].des = type
  }
}

/**
 * 进行组件的联通关系记录,并在特定时机还原对应的连通关系
 * @param {Array} elements //进行连通性检测的数组
 * @param {Number} oldWrapperW //父容器在pc端的宽度
 * @param {Number} oldWrapperH //父容器在pc端的高度
 * @param {Number} newWrapperW //父容器在移动端的宽度
 * @param {Number} newWrapperH //父容器在移动端的高度
 * @param {string} mergeType //合并类型
 *
 */
export class MergeRelation {
  constructor(elements, oldWrapperW, oldWrapperH, newWrapperW, newWrapperH) {
    this.elements = elements.map(it => (it.hasOwnProperty("options") ? it.options : it))
    this.oldWrapperW = oldWrapperW
    this.oldWrapperH = oldWrapperH
    this.newWrapperW = newWrapperW
    this.newWrapperH = newWrapperH
    this.currMergeRelation = null
    this.initMergeRelation(this.elements, this.oldWrapperW, this.oldWrapperH)
  }
  /**
   *初始化联通关系,判定组件是否连通，目前判断组件的紧贴连通
   * @param {array<Object>} elements 当前容器中的所有组件集合，注意，需要是能直接从集合中任一元素中取到配置项的，例如item.left，如果是类似item.options.left则不行
   * @param {number} wrapperW 当前容器宽度
   * @param {number} wrapperH 当前容器高度
   * @returns {array | boolean} 当当前容器中所有组件均没有任何连通关系时，则返回一个布尔值false，否则则返回容器中所有组件的连通关系
   */
  initMergeRelation(elements, wrapperW, wrapperH) {
    const tools = new HandleSize(wrapperW, wrapperH)
    elements.sort(
      (a, b) =>
        Math.sqrt(Math.pow(a.left, 2) + Math.pow(a.top, 2)) - Math.sqrt(Math.pow(b.left, 2) + Math.pow(b.top, 2))
    )
    const u = new union_merge(elements.length)
    let status = false
    for (let i = 0; i < elements.length; i++) {
      const a = elements[i]
      for (let j = i + 1; j < elements.length; j++) {
        const b = elements[j]
        //判定两个组件是否紧贴
        const hadMergeType = getMergeType(a, b, tools)
        //1.如果hadMergeType为真，则证明两个组件相互有关联（对齐或者紧贴）
        //2.且满足当前跟随组件之前没有跟随过别的组件
        //3.如果当前组件有已经确定跟随的组件时，则判断之前跟随的和现在需要跟随的两个组件中，离哪个近，就保留哪个跟随关系
        if (hadMergeType && (u.arr[j].followIndex === null || isMoreClose(u, i, j, elements, tools))) {
          status = true
          u.merge(i, j, hadMergeType)
        }
      }
    }
    this.currMergeRelation = status ? u.arr : status
  }
  /**
   * 还原组件的联通关系,通常用于自适应时,组件的大小位置改变后,还原改变前的连通关系
   */
  reMergeElements() {
    try {
      const tools = new HandleSize(this.newWrapperW, this.newWrapperH)
      //组件数量大于1且组件之间有连通关系
      if (this.elements.length > 1 && Array.isArray(this.currMergeRelation)) {
        const rootItem = this.currMergeRelation.filter(item => item.rootIndex === item.myIndex)
        let otherItem = this.currMergeRelation.filter(item => item.rootIndex !== item.myIndex)
        let start = 0
        //遍历所有头节点，找到非头节点中，以头节点为起点的所有集合，进行紧贴还原处理
        while (start !== rootItem.length) {
          const item = rootItem[start++] //当前集合中的头节点
          const currUnion = [] //跟随头节点的集合
          const newOtherItem = [] //不是跟随当前头节点的集合
          for (let i = 0; i < otherItem.length; i++) {
            //根据头节点下标，对虽有节点进行遍历
            if (otherItem[i].rootIndex === item.myIndex) currUnion.push(otherItem[i])
            else newOtherItem.push(otherItem[i])
          }
          otherItem = newOtherItem
          this.deepReMerge(item, currUnion, tools)
        }
      }
      for (let i = 0; i < this.elements.length; i++) {
        checkEleOverflow(this.elements[i], tools, this.newWrapperW, this.newWrapperH)
      }
    } catch (error) {
      console.log(error)
    }
  }
  /**
   * 递归的对一条连通关系集合内的组件进行还原
   * @param {object} root 头组件
   * @param {array} union  当前的存在同一个连通关系的集合
   * @param {object} tools 一个工具类 ,由HandleSize实例化而来
   * @returns
   */
  deepReMerge(root, union, tools) {
    if (union.length < 1) return
    let followUnion = []
    const otherUnion = []
    for (let i = 0; i < union.length; i++) {
      if (union[i].followIndex === root.myIndex) followUnion.push(union[i])
      else otherUnion.push(union[i])
    }
    if (followUnion.length) {
      for (let i = 0; i < followUnion.length; i++) {
        const followItem = followUnion[i]
        const currEle = this.elements[followItem.myIndex] //当前跟随节点的组件配置项
        const followedEle = this.elements[root.myIndex] //当前被跟随节点的组件配置项
        if (followItem?.des?.mergeType === "close") this.closeMerge(currEle, followedEle, followItem, tools)
        else if (followItem?.des?.mergeType === "align") this.alignMerge(currEle, followedEle, followItem, tools)
        this.deepReMerge(followItem, otherUnion, tools)
      }
    }
  }
  /**
   *
   *   CLOSE: "CLOSE", //紧贴
   *   ALIGN_COLUM_TOP: "ALIGN_COLUM_TOP", //垂直列的上对齐
   *   ALIGN_COLUM_MIDDLE: "ALIGN_COLUM_MIDDLE", //垂直列的居中对齐
   *   ALIGN_COLUM_BOTTOM: "ALIGN_COLUM_BOTTOM", //垂直列的底部对齐
   *   ALIGN_ROW_LEFT: "ALIGN_ROW_LEFT", //水平行的左对齐
   *   ALIGN_ROW_CENTER: "ALIGN_ROW_CENTER", //水平行的居中对齐
   *   ALIGN_ROW_RIGHT: "ALIGN_ROW_RIGHT" //水平行的右对齐
   * @param {object} currEle 跟随组件options
   * @param {object} followedEle 被跟随组件options
   * @param {object} followItem 被跟随组件在并查集中的描述
   * @param {object} tools 一个工具类 ,由HandleSize实例化而来
   */
  alignMerge(currEle, followedEle, followItem, tools) {
    const { alignType, value } = followItem.des.unionType
    switch (alignType) {
      case "ALIGN_COLUM_TOP":
        currEle.top = followedEle.top
        currEle.left = followedEle.left + tools.getRealSize(followedEle, "width") + value
        break
      case "ALIGN_COLUM_MIDDLE":
        currEle.top =
          followedEle.top + (tools.getRealSize(followedEle, "height") / 2 - tools.getRealSize(currEle, "height") / 2)
        currEle.left = followedEle.left + tools.getRealSize(followedEle, "width") + value
        break
      case "ALIGN_COLUM_BOTTOM":
        currEle.top =
          followedEle.top + (tools.getRealSize(followedEle, "height") - tools.getRealSize(currEle, "height"))
        currEle.left = followedEle.left + tools.getRealSize(followedEle, "width") + value
        break
      case "ALIGN_ROW_LEFT":
        currEle.left = followedEle.left
        currEle.top = followedEle.top + tools.getRealSize(followedEle, "height") + value
        break
      case "ALIGN_ROW_CENTER":
        currEle.left =
          followedEle.left + (tools.getRealSize(followedEle, "width") / 2 - tools.getRealSize(currEle, "width") / 2)
        currEle.top = followedEle.top + tools.getRealSize(followedEle, "height") + value
        break
      case "ALIGN_ROW_RIGHT":
        currEle.left =
          followedEle.left + (tools.getRealSize(followedEle, "width") - tools.getRealSize(currEle, "width"))
        currEle.top = followedEle.top + tools.getRealSize(followedEle, "height") + value
        break

      default:
        break
    }
  }
  /**
   *
   * @param {object} currEle 跟随组件options
   * @param {object} followedEle 被跟随组件options
   * @param {object} followItem 被跟随组件在并查集中的描述
   * @param {object} tools 一个工具类 ,由HandleSize实例化而来
   */
  closeMerge(currEle, followedEle, followItem, tools) {
    switch (followItem?.des?.unionType) {
      case "top":
        currEle.top = followedEle.top + tools.getRealSize(followedEle, "height")
        break
      case "right":
        currEle.left = followedEle.left - tools.getRealSize(currEle, "width")
        break
      case "bottom":
        currEle.top = followedEle.top - tools.getRealSize(currEle, "height")
        break
      case "left":
        currEle.left = followedEle.left + tools.getRealSize(followedEle, "width")
        break

      default:
        break
    }
    //处理 因为对齐导致组件超出父容器的场景
  }
}
//判定两个dom之间的距离
function isMoreClose(u, i, j, elements, tools) {
  const distance1 = getMinDistance(elements[u.arr[j].followIndex], elements[u.arr[j].myIndex], tools)
  const distance2 = getMinDistance(elements[u.arr[i].myIndex], elements[u.arr[j].myIndex], tools)
  return distance2 < distance1
}
function getMinDistance(ele1, ele2, tools) {
  //如果两个组件相互覆盖，则返回覆盖面积
  const coveredSize = isCovered(ele1, ele2, tools)
  if (coveredSize > 0) return -getFarDistance(ele1, ele2, tools)
  //如果两个组件的x轴或y轴重叠 则返回直线距离
  const sameLine = isSameLine(ele1, ele2, tools)
  if (typeof sameLine === "number") return sameLine
  //返回最短直线距离
  return getFarDistance(ele1, ele2, tools)
}
function getFarDistance(ele1, ele2, tools) {
  const { top: T1, left: L1 } = ele1
  const { top: T2, left: L2 } = ele2
  const W1 = tools.getRealSize(ele1, "width")
  const W2 = tools.getRealSize(ele2, "width")
  const H1 = tools.getRealSize(ele1, "height")
  const H2 = tools.getRealSize(ele2, "height")
  const x1 = L1 + W1 / 2
  const y1 = T1 + H1 / 2
  const x2 = L2 + W2 / 2
  const y2 = T2 + H2 / 2
  const Dx = Math.abs(x2 - x1)
  const Dy = Math.abs(y2 - y1)
  const delta_x = Dx - (W1 + W2) / 2
  const delta_y = Dy - (H1 + H2) / 2
  return Math.sqrt(delta_x * delta_x + delta_y * delta_y)
}
//这两个组件是否在x轴或者y轴上有重叠，有的话就计算重叠轴的距离
function isSameLine(ele1, ele2, tools) {
  let res = false
  const { top: T1, left: L1 } = ele1
  const { top: T2, left: L2 } = ele2
  const W1 = tools.getRealSize(ele1, "width")
  const W2 = tools.getRealSize(ele2, "width")
  const H1 = tools.getRealSize(ele1, "height")
  const H2 = tools.getRealSize(ele2, "height")
  //两组组件的y轴区间发生了重合
  if ((T1 >= T2 && T1 <= T2 + H2) || (T2 >= T1 && T2 <= T1 + H1)) {
    //ele2在ele1前面
    if (L1 >= L2 + W2) {
      res = L1 - L2 - W2
    } else {
      //ele1在ele2前面
      res = L2 - L1 - W1
    }
  } else if ((L1 >= L2 && L1 <= L2 + W2) || (L2 >= L1 && L2 <= L1 + W1)) {
    //两组组件的x轴区间发生了重合
    //ele2在ele1上面
    if (T1 >= T2 + H2) {
      res = T1 - T2 - H2
    } else {
      //ele1在ele2上面
      res = T2 - T1 - H1
    }
  }
  return res
}
/**
 *
 * @param {string} mergeType 连通类型
 * @param {string | object} unionType 与上一级的联通关系
 */
function MergeTypes(mergeType, unionType) {
  this.mergeType = mergeType
  this.unionType = unionType
}
/**
 * 用于记录当前容器内的组件连通性，且在当容器内的组件的宽高大小发生改变后，还原他们的紧贴连通关系
 */
const mergeMap = {
  CLOSE: "CLOSE", //紧贴
  ALIGN_COLUM_TOP: "ALIGN_COLUM_TOP", //垂直列的上对齐
  ALIGN_COLUM_MIDDLE: "ALIGN_COLUM_MIDDLE", //垂直列的居中对齐
  ALIGN_COLUM_BOTTOM: "ALIGN_COLUM_BOTTOM", //垂直列的底部对齐
  ALIGN_ROW_LEFT: "ALIGN_ROW_LEFT", //水平行的左对齐
  ALIGN_ROW_CENTER: "ALIGN_ROW_CENTER", //水平行的居中对齐
  ALIGN_ROW_RIGHT: "ALIGN_ROW_RIGHT" //水平行的右对齐
}
function getMergeType(a, b, tools) {
  const alignMerge = checkAlign(a, b, tools)
  if (alignMerge) return new MergeTypes("align", alignMerge)
  const isCloseAlign = checkClose(a, b, tools)
  return isCloseAlign ? new MergeTypes("close", isCloseAlign) : false
}
//判定两个组件是否挨着
function checkClose(a, b, tools) {
  //上下挨着 左右挨着，上下左右交换挨着
  if (hitTolerance(a.left + tools.getRealSize(a, "width"), b.left)) return "left"
  if (hitTolerance(a.top + tools.getRealSize(a, "height"), b.top)) return "top"
  if (hitTolerance(b.left + tools.getRealSize(b, "width"), a.left)) return "right"
  if (hitTolerance(b.top + tools.getRealSize(b, "height"), a.top)) return "bottom"
  return false
}
//判定两个组件是否存在对齐关系
function checkAlign(ele1, ele2, tools) {
  if (isCovered(ele1, ele2, tools)) return false
  const ele1W = tools.getRealSize(ele1, "width")
  const ele1H = tools.getRealSize(ele1, "height")
  const ele2W = tools.getRealSize(ele2, "width")
  const ele2H = tools.getRealSize(ele2, "height")
  //left center right 对应左中右 top middle bottom 对应上中下
  const { left: left1, top: top1 } = ele1
  const { left: left2, top: top2 } = ele2
  const center1 = left1 + ele1W / 2
  const center2 = left2 + ele2W / 2
  const right1 = left1 + ele1W
  const right2 = left2 + ele2W
  const middle1 = top1 + ele1H / 2
  const middle2 = top2 + ele2H / 2
  const bottom1 = top1 + ele1H
  const bottom2 = top2 + ele2H
  //水平行的居中对齐
  if (hitTolerance(center1, center2)) return { alignType: mergeMap.ALIGN_ROW_CENTER, value: top2 - top1 - ele1H }
  //垂直列的居中对齐
  if (hitTolerance(middle1, middle2)) return { alignType: mergeMap.ALIGN_COLUM_MIDDLE, value: left2 - left1 - ele1W }
  //水平行的左对齐
  if (hitTolerance(left1, left2)) return { alignType: mergeMap.ALIGN_ROW_LEFT, value: top2 - top1 - ele1H }
  //水平行的右对齐
  if (hitTolerance(right1, right2)) return { alignType: mergeMap.ALIGN_ROW_RIGHT, value: top2 - top1 - ele1H }
  //垂直列的上对齐
  if (hitTolerance(top1, top2)) return { alignType: mergeMap.ALIGN_COLUM_TOP, value: left2 - left1 - ele1W }
  //垂直列的底部对齐
  if (hitTolerance(bottom1, bottom2)) return { alignType: mergeMap.ALIGN_COLUM_BOTTOM, value: left2 - left1 - ele1W }
  return false
}
//是否命中公差
function hitTolerance(n1, n2) {
  if (n1 === n2) return true
  return Math.abs(Math.abs(n1) - Math.abs(n2)) < minDistance
}
